let breadcrumb = [];

export function setBreadcrumb(requireComponent) {
  requireComponent.keys().forEach(fileName => { breadcrumb = [...breadcrumb, ...requireComponent(fileName).default] } );
}

export function getBreadcrumb() {
  return breadcrumb;
}

export { breadcrumb };
